import 'echarts/lib/chart/candlestick';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { merge } from 'lodash';

import ChartService from './ChartService';

export default class ChartDefaultService extends ChartService {
  buildChartData(visualization) {
    return merge(this.defaultChartOptions, visualization);
  }
}
